(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-policy-list"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'click',
    (event) => {
      const link =
        event.target instanceof Element
          ? event.target.closest('.terms-policies-popover a[href$="#shopifyReshowConsentBanner"]')
          : null;
      const popover = link?.closest('[popover]');

      if (popover?.matches(':popover-open') && typeof popover.hidePopover === 'function') {
        popover.hidePopover();
      }
    },
    { capture: true }
  );
  } catch(e) { console.error(e); }
})();

})();
